/*
 * 注册全局组件
 */
import Vue from 'vue';
import { Toast, Dialog } from 'vant';
import piContent from '../components/pi-content/pi-content';
import piButton from '../components/pi-button/pi-button';

Vue.use(Toast);
Vue.use(Dialog);
Vue.component(piContent.name, piContent);
Vue.component(piButton.name, piButton);
